// Lazy loader + minimal typing for the CloudPayments payment widget. The script
// is fetched only when the gateway selects the CloudPayments provider, so the
// offline mock checkout path stays fully network-free.
//
// The widget collects the card and runs 3-D Secure in its own popup; on success
// we finalize the order server-side (the charge is verified by InvoiceId — the
// onSuccess callback carries no transaction id).

export type PayOptions = {
	publicId: string;
	description: string;
	amount: number;
	currency: string;
	invoiceId: string;
	accountId?: string;
	skin?: "classic" | "modern" | "mini";
	data?: Record<string, unknown>;
	/** fd-payment-01: сохранить карту (токен придёт в уведомлении Pay). */
	tokenize?: boolean;
};

type PayCallbacks = {
	onSuccess?: (options: PayOptions) => void;
	onFail?: (reason: string, options: PayOptions) => void;
	onComplete?: (result: unknown, options: PayOptions) => void;
};

type CloudPaymentsWidget = {
	pay(scenario: "charge" | "auth", options: PayOptions, callbacks?: PayCallbacks): void;
};

type CloudPaymentsGlobal = {
	CloudPayments: new () => CloudPaymentsWidget;
};

declare global {
	interface Window {
		cp?: CloudPaymentsGlobal;
	}
}

const SCRIPT_SRC = "https://widget.cloudpayments.ru/bundles/cloudpayments";
let loader: Promise<CloudPaymentsGlobal> | null = null;

export const loadCloudPayments = (): Promise<CloudPaymentsGlobal> => {
	if (window.cp) return Promise.resolve(window.cp);
	if (loader) return loader;
	loader = new Promise<CloudPaymentsGlobal>((resolve, reject) => {
		const script = document.createElement("script");
		script.src = SCRIPT_SRC;
		script.async = true;
		script.onload = () =>
			window.cp ? resolve(window.cp) : reject(new Error("CloudPayments failed to load"));
		script.onerror = () => reject(new Error("CloudPayments failed to load"));
		document.head.appendChild(script);
	});
	return loader;
};

/**
 * 3-D Secure при оплате сохранённой картой (fd-payment-01): банк ждёт
 * покупателя формой POST с PaReq, MD и адресом возврата — так требует
 * протокол. Вернувшись, шлюз завершит списание и уведёт на /pay/<заказ>.
 */
export const submitAcsForm = (input: { acsUrl: string; paReq: string; md: string; termUrl: string }): void => {
	const form = document.createElement("form");
	form.method = "POST";
	form.action = input.acsUrl;
	for (const [name, value] of [
		["PaReq", input.paReq],
		["MD", input.md],
		["TermUrl", input.termUrl],
	] as const) {
		const field = document.createElement("input");
		field.type = "hidden";
		field.name = name;
		field.value = value;
		form.appendChild(field);
	}
	document.body.appendChild(form);
	form.submit();
};
